import { injectable, inject } from 'inversify';
import { TYPES } from '@framework/config/DI/types';
import { DomainConfig } from '@framework/config/DI/domainModule/DomainConfig';
import { IConfig } from '../IConfig';
import config from '../config';

@injectable()
class ConfigFactory {
  constructor(
    @inject(TYPES.DomainConfig) private domain: DomainConfig,
  ) {}

  create(): IConfig {
    return {
      ...config,
      hostname: this.domain.creditflowresearchDomain,
      newissueEmail: `newissue@${ this.domain.finsightDomain }`,
      api: {
        ...config.api,
        external: `${ this.domain.protocol }//${ this.domain.finsightDomain }`,
      },
    };
  }
}

export default ConfigFactory;
